import React, { useCallback, useEffect, useState } from "react";
import { Form, Select, Input, DatePicker } from "antd";
import CustomButton from "components/Common/buttons/CustomButton";
import useStoreFilters from "customHooks/useStoreFilters";
import { FILTER_PAGE, USER_TENANT_NAME } from "utils/constants";
import moment from "moment";
import { inputPatternTitle, inputTextPattern } from "components/Common/inputs/variables";
import { makeStyles } from "@material-ui/core/styles";
import { customDateFormatWithoutTime } from "components/Common/formatter";
import { searchOptions, TRIP_STATUSES, dateFormat } from "pages/stock-management/trips/constants";
import NGISelect from "components/Common/inputs/NGISelect";
import { useSelector } from "react-redux";
import { DictionariesSelector } from "store/dictionaries/selectors";

const { Option } = Select;

const useStyles = makeStyles({
  root: {
    width: "130px!important",
  },
});
const TripSearch = ({ handleSearch }) => {
  const classes = useStyles();
  const [form] = Form.useForm();
  const [selectedFilter, setSelectedFilter] = useState("");
  const { filters, getFilters } = useStoreFilters(FILTER_PAGE.TRIP);

  const {
    list: { truckLicensePlates },
  } = useSelector(DictionariesSelector);

  useEffect(() => {
    if (!!filters) {
      const property = Object.keys(filters).find(key => searchOptions.find(option => option.value === key));
      const value = filters[property];
      if (filters?.tripDate) {
        form.setFieldsValue({
          type: "tripDate",
          tripDate: moment(filters?.tripDate),
        });
        setSelectedFilter("date");
      }
      if (searchOptions.find(item => item.value === property)) {
        form.setFieldsValue({
          type: property,
          value: value,
        });
        setSelectedFilter(property);
      }
    } else {
      form.setFieldsValue({
        type: null,
        value: null,
      });
    }
  }, []);

  const onSearch = useCallback(values => {
    const { pageSize } = getFilters();

    if (values?.type === "tripDate") {
      const filter = { pageSize };
      filter.tripDate = customDateFormatWithoutTime(values?.tripDate);
      handleSearch(filter);
    } else {
      !(values.value && !values.type) &&
        handleSearch(values.type ? { [values.type]: values.value?.trim(), pageSize } : {});
    }
  }, []);

  const onChangeFilter = useCallback(value => {
    setSelectedFilter(value);
    form.setFieldsValue({
      value: null,
    });
  }, []);

  return (
    <div className="custom-filter">
      <Form form={form} name="horizontal_login" layout="inline" onFinish={onSearch}>
        <Form.Item name="type">
          <Select
            onChange={onChangeFilter}
            style={{ width: "100%" }}
            tokenSeparators={[","]}
            placeholder="Select type"
            allowClear
          >
            {searchOptions.map(item => (
              <Option key={item.value} value={item.value}>
                {item.title}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <>
          {selectedFilter === "tripNumber" && (
            <>
              <div className="filter-divider" />
              <Form.Item name="value">
                <Input placeholder={"Enter value"} allowClear pattern={inputTextPattern} title={inputPatternTitle} />
              </Form.Item>
            </>
          )}

          {selectedFilter === "truckLicensePlate" && (
            <Form.Item name="value">
              <NGISelect showSearch placeholder={"Select value"}>
                {truckLicensePlates &&
                  truckLicensePlates[USER_TENANT_NAME()] &&
                  truckLicensePlates[USER_TENANT_NAME()]?.map(item => (
                    <Option key={item} value={item}>
                      {item}
                    </Option>
                  ))}
              </NGISelect>
            </Form.Item>
          )}

          {selectedFilter === "status" && (
            <>
              <div className="filter-divider" />
              <Form.Item name="value">
                <Select showSearch style={{ width: "100%" }} tokenSeparators={[","]} placeholder={"Select value"}>
                  {Object.keys(TRIP_STATUSES).map(item => (
                    <Option key={item} value={TRIP_STATUSES[item]}>
                      {TRIP_STATUSES[item]}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </>
          )}

          {selectedFilter === "tripDate" && (
            <>
              <div className="filter-divider" />
              <Form.Item
                name="tripDate"
                rules={[{ required: true, message: "Please select date" }]}
                className={classes.root}
              >
                <DatePicker inputReadOnly={true} bordered={false} format={dateFormat} size={"default"} />
              </Form.Item>
            </>
          )}
        </>

        <CustomButton type="primary" htmlType="submit" size="small" text="Search" />
      </Form>
    </div>
  );
};

export default TripSearch;
